import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import TonnageModel from '../models/TonnageModel';
import TonnageQueryModel from '../models/TonnageQueryModel';
import TonnageNameModel from '../models/TonnageNameModel';
import TonnageOperatorHistoryModel from '../models/TonnageOperatorHistory';

interface tonnageOperatorHistoryModalState {
    open: boolean,
    operatorHistories: TonnageOperatorHistoryModel[],
    tonnageId: string
}

const initialState: tonnageOperatorHistoryModalState = {
    open: false,
    operatorHistories: [],
    tonnageId: ""
}

export const TonnageOperatorHistoryModalSlice = createSlice({
    name: "TonnageOperatorHistory",
    initialState,
    reducers: {
        setModalOpen: (state, action: PayloadAction<boolean>) => {
            state.open = action.payload;
        },
        setTonnageHistories: (state, action: PayloadAction<TonnageOperatorHistoryModel[]>) => {
            state.operatorHistories = action.payload;
        },
        setTonnageId: (state, action: PayloadAction<string>) => {
            state.tonnageId = action.payload;
        },
    }
});

export const tonnageOperatorHistoryModalSelector = createSelector(
    (state: RootState) => state.tonnageOperatorHistoryModalSelector,
    (data) => data
);

export const {
    setModalOpen,
    setTonnageHistories,
    setTonnageId,
} = TonnageOperatorHistoryModalSlice.actions;

export default TonnageOperatorHistoryModalSlice.reducer;